import { ComponentProps, ReactNode } from 'react';

import ConditionalTooltip from '@components/ConditionalTooltip';
import styles from '@components/text/Link.module.css';
import InternalLink from '@components/typography/InternalLink';

type Props = Omit<
  ComponentProps<typeof InternalLink>,
  'aria-describedby' | 'onBlur' | 'onFocus' | 'role' | 'tabIndex'
> & {
  hoverContent?: ReactNode;
};

const Link = ({ hoverContent, ...linkProps }: Props) => (
  <ConditionalTooltip condition={!!hoverContent} content={hoverContent}>
    {tooltipTriggerProps => <InternalLink className={styles.routerLink} {...linkProps} {...tooltipTriggerProps} />}
  </ConditionalTooltip>
);

export default Link;
